"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clipboardPolyfill = require("clipboard-polyfill");
var copyToClipboard = function copyToClipboard(text) {
  if (text) (0, _clipboardPolyfill.writeText)(text);
};
var _default = copyToClipboard;
exports.default = _default;